import script from "./InvestimentosFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestimentosFormView.vue?vue&type=script&setup=true&lang=js"

import "./InvestimentosFormView.vue?vue&type=style&index=0&id=40fb84cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40fb84cc"]])

export default __exports__